import React, { useState } from 'react';

import Button from 'shared/button';
import DromoImporterButton from 'components/dromo/importer_button';
import Modal from 'components/modal';
import RadioInput from '../components/radio_input';
import { getDromoImporterConfig, LEASE, SALE } from './config';

import type { CompType } from './config';
import type { CustomField } from 'bundles/apex/custom_fields/types';
import type { DromoImporterProps, Import } from 'components/dromo/types';

export interface Props {
  addImport: (newImport: Import) => void;
  customFields: CustomField[];
  dromoImporterProps: DromoImporterProps;
  onHide: () => void;
}

export default function CompsImportsSettings({
  addImport,
  customFields,
  dromoImporterProps,
  onHide,
}: Props) {
  const [compType, setCompType] = useState<CompType>(null);
  const [showDromo, setShowDromo] = useState(false);

  return <>
    <Modal.Body>
      <div className="d-flex flex-column gap-3 m-3">
        <b>Import Sale or Lease Comps</b>
        <RadioInput
          checked={compType === SALE}
          label="Sale Comps"
          subtext="Sale transaction records including pricing, financials, and associated parties."
          onClick={() => setCompType(SALE)}
        />
        <RadioInput
          checked={compType === LEASE}
          label="Lease Comps"
          subtext="Lease transaction records including rental rates, lease terms, and tenant details."
          onClick={() => setCompType(LEASE)}
        />
      </div>
    </Modal.Body>
    <Modal.Footer className="d-flex align-items-center justify-content-end">
      <Button.Cancel onClick={onHide} />
      <DromoImporterButton
        dromoImporterConfig={getDromoImporterConfig(compType, customFields)}
        dromoImporterProps={dromoImporterProps}
        setShowDromo={setShowDromo}
        showDromo={showDromo}
        onCreate={addImport}
      />
    </Modal.Footer>
  </>;
}
